export const ImageRoutes = {
  hydrate(image) {
    return {
      src: image.m,
      ...image,
    };
  },
};
